<template>
  <div class="page-header pt-5 pb-11 m-3">
    <span class="mask bg-gradient-dark"></span>
    <div class="grid grid-nogutter">
      <div class="col-12 flex justify-content-center mt-5">
        <img :src="getLogo" height="100" />
      </div>
    </div>

    <div class="wrapper-form" style="margin-top:100px">
      <div class="grid">
        <div class="xl:col-4 lg:col-5 md:col-7 col-9 mx-auto">
          <div class="card">
            <div class="card-body text-center p-5">
              <i class="pi pi-check-circle" style="font-size: 5rem; color: green; margin-bottom: 20px;"></i>
              <h2 class="text-2xl font-bold mb-3">Pagamento Confermato!</h2>
              <p class="mb-5">La transazione è andata a buon fine. Grazie per il tuo pagamento.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer py-5">
    <div class="grid">
      <div class="col-8 mx-auto text-center mt-1">
        <p class="mb-0">©{{ currentYear }} made ASK Team Software</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  computed: {
    getLogo(){
      const LOGO = `${process.env.VUE_APP_LOGO}`;
      return LOGO
    }
  },
  setup() {
    const currentYear = computed(() => new Date().getFullYear())

    return { currentYear }
  }
}
</script>

<style scoped>
.page-header {
  z-index: 1;
  height: 100vh;
  min-height: 100vh;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  background-size: cover;
  margin: 0 !important; /* Override m-3 */
}

.mask {
  z-index: -2;
  position: absolute;
  background-size: cover;
  background-position: center center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  background: #0098f0 !important;
  background: linear-gradient(90deg, rgb(27, 51, 89) 0%, rgb(32, 89, 122) 100%) !important;
}

.btn-signin {
  all: unset;
  color: white;
  background-color: #000;
  display: block;
  width: 100%;
  padding: 14px 1px;
  border-radius: 0.5rem;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.btn-signin:hover {
  opacity: 0.9;
}

.card {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: #fff !important;
}

.footer p {
    color: rgba(255,255,255,0.7);
}
</style>
